import * as React from 'react';

var _path;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.989 4.985a3.693 3.693 0 00-3.693 3.692v1.662h.739V8.677a2.954 2.954 0 015.907 0v1.662h.739V8.677a3.693 3.693 0 00-3.692-3.692zM6.635 11.63h10.708v7.384H6.635v-7.384zm.738.738v5.908h9.231v-5.908h-9.23zm4.246 2.954v-1.662h.739v1.662h-.739z"
  })));
}

export { SvgLock as default };